<template>
  <m-base
    :showTopBorder="pattern.showTopBorder"
    :showRightBorder="pattern.showRightBorder"
    :showBottomBorder="pattern.showBottomBorder"
    :showLeftBorder="pattern.showLeftBorder"
    :showHeader="false"
    :showPadding="false"
    :showLeftPadding="pattern.showLeftPadding"
    :showRightPadding="pattern.showRightPadding"
    :showTopPadding="pattern.showTopPadding"
    :showBottomPadding="pattern.showBottomPadding"
    :showBorderRadius="pattern.showBorderRadius"
    :boxType="pattern.boxType"
    :backgroundColor="pattern.backgroundColor"
  >
    <div slot="content" class="box-section-scroll">
      <div
        v-for="(item,index) in data"
        :key="index"
        class="d-inline-block"
        :style="{width: (100 / 2.5 )+'%' ,margin:pattern.showSpace?'0 5px':'0px'
        }"
      >
        <van-image lazy-load
          :src="item.src"
          mode="widthFix"
          :class="{'img-radius':pattern.showImgBorderRadius}"
          @click="navToDetailPage(item,index)"
        />
      </div>
    </div>
  </m-base>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => { }
    },
    data: {
      type: Array,
      default: () => [{
        src: '',
        navTo: ''
      },
      {
        src: '',
        navTo: ''
      }
      ]
    },
    pattern: {
      type: Object,
      default: () => {
        return {
          showTopBorder: false,
          showRightBorder: false,
          showBottomBorder: true,
          showLeftBorder: false,
          showBorderRadius: false,
          showLeftPadding: true,
          showRightPadding: true,
          showTopPadding: true,
          showBottomPadding: true,
          showSpace: true,
          showImgBorderRadius: false,
          boxType: 'block',
          backgroundColor: 'rgba(255,255,255,1)',
        }
      }
    },
  },
  data () {
    return {

    };
  },
  methods: {
    navToDetailPage (item, index) {
      let navTo = item.navTo
      if (navTo) {
        if (navTo.indexOf('http') > -1) {
          window.location.href = navTo
        } else {
          this.$router.push(this.$uitl.getPathQuery(navTo))
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.box-section-scroll {
  white-space: nowrap;
  overflow-x: scroll;
  overflow-y: hidden;
  
}
.box-section-scroll::-webkit-scrollbar {display: none; /* Chrome Safari */}

img {
  display: block;
  max-width: 250px;
}

.width {
  width: 17px;
}
.img-radius {
  border-radius: 12px;
  overflow: hidden;
}
</style>
